import React from 'react';
import './CTASection.css';

const CTASection: React.FC = () => {
  return (
    <section className="cta" id="cta">
      <div className="cta-inner reveal">
        <div className="cta-callout">Next available call: This week</div>
        <h2>Ready to get your<br />time back?</h2>
        <p className="cta-sub">
          Book a free 30-minute call. Tell us about your business. We'll show you exactly what
          we'd fix, what it's worth, and what it costs. No obligation. No jargon. No pressure.
        </p>
        <div className="cta-actions">
          <a href="#" className="btn btn-solid" style={{ fontSize: '1.05rem', padding: '17px 34px' }}>
            Book My Free 30-Minute Call &rarr;
          </a>
          <a href="mailto:hello@sortmybusinesswithai.com" className="btn btn-ghost" style={{ fontSize: '1.05rem', padding: '17px 34px' }}>
            Send Us an Email
          </a>
        </div>
        <div className="cta-reassure">
          <span>Free. No commitment.</span>
          <span>No tech knowledge needed</span>
          <span>Any business, any sector</span>
          <span>Ireland &amp; UK only</span>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
